<template>
  <component
    :is="tag"
    :to="to"
    :class="{ 'btn--white': white, 'btn--square': square, 'btn--green': green }"
    v-bind="attrs"
    class="btn"
    @click="handleClick"
  >
    <span v-if="badge" class="badge">{{ badge }}</span>
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      validator: prop => ['button', 'a', 'router-link'].includes(prop),
      default: 'button'
    },
    gray: {
      type: Boolean,
      default: false
    },
    yellow: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    },
    green: {
      type: Boolean,
      default: false
    },
    square: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    to: {
      type: [String, Object],
      default: ''
    },
    badge: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    classes() {
      return {
        'btn--gray': this.gray,
        'btn--yellow': this.yellow,
        'btn--locked': this.locked
      }
    },
    attrs() {
      return this.tag === 'button' ? { type: 'button' } : {}
    }
  },
  methods: {
    handleClick($event) {
      this.$emit('click', $event)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  width: 100%;
  border: none;
  text-decoration: none;
  padding: 15px 20px;
  display: block;
  background: $navy;
  border-radius: $border-radius;
  box-shadow: $box-shadow;
  text-align: center;
  font-size: 15px;
  line-height: 1;
  font-weight: 500;
  text-transform: uppercase;
  color: $white;
  cursor: pointer;
  outline: none;
  position: relative;
  transition: $time;

  &:hover,
  &:active {
    background: rgba($navy, 0.85);
  }

  & + .btn {
    margin: 0 0 0 24px;
  }

  &--gray {
    width: 220px;
    background: #f2f2f2;

    @include media-down(md) {
      margin: 10px auto 0;
    }
  }

  &--yellow {
    width: 220px;

    @include media-down(md) {
      margin: 0 auto;
    }
  }

  &--white {
    background: $white;
    box-shadow: $box-shadow-dark;

    &:hover {
      background: $white;
    }
  }

  &--green {
    background: $green;

    &:hover {
      background: lighten($green, 10%);
    }
  }

  &--square {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 58px;
    height: 58px;
  }

  &--locked {
    filter: grayscale(40%);
    pointer-events: none;
  }
}

.badge {
  @include size(20px);
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 1;
  border-radius: 50%;

  background-color: $status-failed;
  color: $white;

  font-size: 13px;
  line-height: 20px;
  text-align: center;
}
</style>
